import { useSimulation } from "../simulation/SimulationProvider";

export function InformationPanel() {
  const { snapshot } = useSimulation();

  return (
    <section className="information-panel" aria-labelledby="teaching-readout">
      <h2 id="teaching-readout">Notes</h2>
      <section aria-labelledby="earth-view-heading">
        <h3 id="earth-view-heading">View from Earth</h3>
        <p>
          <span aria-label="Earth-view phase">{snapshot.phaseName}</span>
        </p>
        <p>North up; horizon orientation varies by location and time.</p>
      </section>
      <dl>
        <div>
          <dt>Current phase</dt>
          <dd>
            <output aria-label="Current phase" aria-live="polite">
              {snapshot.phaseName}
            </output>
          </dd>
        </div>
        <div>
          <dt>Lunar day</dt>
          <dd>{snapshot.lunarDay.toFixed(1)}</dd>
        </div>
        <div>
          <dt>Illuminated</dt>
          <dd>{Math.round(snapshot.illuminatedFraction * 100)}%</dd>
        </div>
        <div>
          <dt>Orbital angle</dt>
          <dd>{Math.round(snapshot.orbitalAngleDegrees)}°</dd>
        </div>
      </dl>
      <p>
        The Sun always illuminates half of the Moon. As the Moon orbits Earth,
        we see a changing fraction of that illuminated hemisphere. Earth’s
        shadow causes lunar eclipses, not ordinary phases.
      </p>
    </section>
  );
}
